import React, { useEffect, useState } from "react";
import ReactQuill from "react-quill";
import { ITextEditor } from "./type";

import "react-quill/dist/quill.snow.css";
import "./styles.css"
import { Box, Typography } from "@mui/material";

const TextEditor: React.FC<ITextEditor> = ({ value, setValue, error }) => {

    useEffect(() => {
    }, [error]);

    const modules = {
        toolbar: [
            [{ size: [] }],
            ["bold", "italic", "underline", "strike"],
            [{ align: ["right", "center", "justify"] }],
            [{ list: "ordered" }, { list: "bullet" }],
            ["link"],
            [{ color: ["#FF493B", "#753130", "#FF968F", "#21212B", "#FFFFFF", "#AFA291"] }],
            [{ background: ["#21212B", "#AFA291"] }],
        ],
    };

    const formats = [
        "header",
        "bold",
        "italic",
        "underline",
        "strike",
        "blockquote",
        "list",
        "bullet",
        "link",
        "color",
        "background",
        "align",
        "size",
        "font",
    ];

    const handleProcedureContentChange = (content: any) => {
        setValue(content);
    };

    return (
        <>
            <ReactQuill
                theme="snow"
                modules={modules}
                formats={formats}
                value={value}
                onChange={handleProcedureContentChange}
                className={(error != null) ? "ql-error" : undefined}
            />
            {error != null &&
                <Typography color="error" className={"MuiFormHelperText-root Mui-error MuiFormHelperText-sizeMedium MuiFormHelperText-root"} >{error}</Typography>}
        </>
    );
}

export default TextEditor;